import bussinesTargetApi from '../api/bussinesTarget.api'


export const bussinesTargetService = (function () {
    'use strict'

    async function getStateTargets (){
        try{
            return bussinesTargetApi.getStateTargets();
        }catch(e){
            console.log('bussinessTargetService - Error al obtener estados: ', e)
        }
        
    }

    async function createUpdateManyStateTarget (objetives) {
        try{
            return bussinesTargetApi.createUpdateManyStateTarget (objetives);

        }catch(e){
            console.log('bussinessTargetService - Error al crear o modificar objetivos: ', e)
        }
    }

    async function deleteObjetives(thingIds){
        try{
        const response = await bussinesTargetApi.delete(thingIds);
        return response;
        }catch(e){
            console.log( 'bussinessTargetService - Error al borrar objetivos: ', e)
        }
    }


return {
 getStateTargets,
 createUpdateManyStateTarget,
 deleteObjetives 
}
})()